<template>
    <div class="item-wrapper" :style='`margin: ${margin}px 0;`'>
        <div class="item-logo" :style='`width: ${size}px;`'>
            <template v-if="logo">
                <div class="item-logo-inner" :style='`background-image: url("${logo}"); width: ${size}px; height: ${size}px;`'> </div>
            </template>
        </div>
        <div class="item-content" :style='`margin-left: ${Number(size) + 20}px; `'>
            <p class="item-content-top">
                <slot name="top">
                </slot>
            </p>
            <p class="item-content-inner">
                <slot name="text">
                </slot>
            </p>
            <p class="item-content-bottom">
                <slot name="bottom">
                </slot>
            </p>
            <template v-if="withBtm">
                <p class="item-content-under-bottom">
                    <slot name="under-bottom">
                    </slot>
                </p>
            </template>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        withBtm: {
            required: false,
            default: false
        },
        logo: {
            required: false,
            type: String,
        },
        size: {
            type: String,
            default: "70",
        },
        margin: {
            type: String,
            default: "20",
        },
    },
};
</script>

<style scoped>
    .item-wrapper{
        position: relative;
        margin: 20px 0;
    }
    .item-logo{
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        height: 100%;
    }
    .item-logo-inner{
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
    }
    .item-content{
        display: flex;
        height: inherit;
        flex-direction: column;

    }
    .item-content-inner, .item-content-under-bottom{
        margin-bottom: 0;
        padding: 5px 0;
        height: fit-content;
        align-self: flex-start;
        font-size: 16px;
        line-height: 16px;
    }
    .item-content-bottom, .item-content-top {
        font-size: 22px;
        line-height: 25px;
        margin: 0
    }
</style>
